// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.AcceptRentAmountChangeWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { AcceptRentAmountChangeWebApiHandler_acceptRentAmountChange } from '@zg-rentals/ts-rent-payment-client';

import type {
  AcceptRentAmountChangeWebApiRequestDto,
  AcceptRentAmountChangeWebApiResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export interface AcceptRentAmountChangeWebApiHandler_acceptRentAmountChange_Args {
  postData: AcceptRentAmountChangeWebApiRequestDto;
}

export type AcceptRentAmountChangeWebApiHandler_acceptRentAmountChange_Options = UseMutationOptions<
  AcceptRentAmountChangeWebApiResponseDto,
  unknown,
  AcceptRentAmountChangeWebApiHandler_acceptRentAmountChange_Args
>;

/**
 * accept rent amount change
 */
export const useAcceptRentAmountChangeWebApiHandler_acceptRentAmountChange = ({
  httpClient,
  ...options
}: Omit<AcceptRentAmountChangeWebApiHandler_acceptRentAmountChange_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: AcceptRentAmountChangeWebApiHandler_acceptRentAmountChange_Args) =>
      AcceptRentAmountChangeWebApiHandler_acceptRentAmountChange(args.postData, httpClient),
  });
};
